import React from "react";

import { useCancel, CancelProvider } from "context/cancelContext";

import Cancel from "./layout";

function CancelContainer() {
  const { loading } = useCancel();
  return <Cancel loading={loading} />;
}

export default () => (
  <CancelProvider>
    <CancelContainer />
  </CancelProvider>
);
